'use client';

import { useEffect, useState } from 'react';

const calculateTpx = (width) => {
  if (width >= 768) {
    // PC端
    return '0.0625rem'; // 假设根字体大小为16px
  } else {
    // 移动端
    return `${100 / 375}vw`; // 假设设计稿宽度为375px
  }
};

export function useTpx() {
  const [tpx, setTpx] = useState('0.0625rem'); // 默认值

  useEffect(() => {
    const handleResize = () => {
      setTpx(calculateTpx(window.innerWidth));
    };

    // 初始设置
    handleResize();

    // 监听窗口大小变化
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return tpx;
}